import { Outlet, useNavigate } from 'react-router-dom';
import { MenuSideBar, NavBar } from 'shared/components';
import { useSessionUser } from 'shared/store/session';
import React, { useState } from 'react';
import { Box, Toolbar } from '@mui/material';
import theme from 'shared/themes/theme';
import {IListItemMenuProps} from 'shared/types/crtlAcess';
import { CrtlAcessService } from 'shared/services/crtlAcess/crtlAcessService';

export default function PaginaPadrao() {
  const user = useSessionUser();
  const navigate = useNavigate();
  const [itensMenu, setItensMenu] = useState<IListItemMenuProps[]>([]);

  React.useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user]);

  React.useEffect(() => {
    CrtlAcessService.getMenu()
      .then((result) => {
        //console.log('menu',result);
        if (result instanceof Error) {
          setItensMenu([]);
        }
        else{
          setItensMenu(result);
        }
        
      }
      );
  }, []);

  return (
    <>
      <NavBar />
      {/*<header className={styles.header}>
      </header>*/}
      <MenuSideBar itensMenu={itensMenu} />      
      <Box sx={{ padding: '0px 0px', height: '100vh', backgroundColor: '#f0f2f5' }}>
        <Toolbar sx={{ height: theme.spacing(20), }} />
        <Outlet />
      </Box>
    </>
  );
}
